import { useCallback, useMemo, useState } from "react";

import { PaymentMode } from "../helpers/stripe";

import { useMediaQuery } from "./useMediaQuery";

import { isSafari } from "@/common/helpers/parseUserAgent";

type UseSupportsExpressCheckoutOptions = {
  forceDisabled?: boolean;
  allowSetupMode?: boolean;
};

export const useSupportsExpressCheckout = (
  paymentMode: PaymentMode,
  { forceDisabled = false, allowSetupMode = false }: UseSupportsExpressCheckoutOptions = {}
) => {
  const { isSmallScreen } = useMediaQuery();

  const safari = useMemo(() => isSafari(), []);

  const setupModeDisabled = paymentMode === "setup" && !allowSetupMode;
  const expressCheckoutDisabled = forceDisabled || (safari && !isSmallScreen) || setupModeDisabled;

  const [isExpressCheckoutLoading, setIsExpressCheckoutLoading] = useState(!expressCheckoutDisabled);
  const [supportsExpressCheckout, setSupportsExpressCheckout] = useState(false);

  const [wasDisabled, setWasDisabled] = useState(expressCheckoutDisabled);
  if (wasDisabled !== expressCheckoutDisabled) {
    setWasDisabled(expressCheckoutDisabled);
    if (!expressCheckoutDisabled) {
      setIsExpressCheckoutLoading(true);
      setSupportsExpressCheckout(false);
    }
  }

  const handleSetSupportsExpressCheckout = useCallback((value: boolean) => {
    setIsExpressCheckoutLoading(false);
    setSupportsExpressCheckout(value);
  }, []);

  return {
    expressCheckoutDisabled,
    isExpressCheckoutLoading: expressCheckoutDisabled ? false : isExpressCheckoutLoading,
    supportsExpressCheckout: expressCheckoutDisabled ? false : supportsExpressCheckout,
    handleSetSupportsExpressCheckout,
  };
};
